import * as React from 'react';
import innerText from 'react-innertext';
import styled from 'styled-components';
import franc from 'franc';
import { useTranslationText } from 'locale';

const Wrapper = styled.a<{ propsStyle: React.CSSProperties }>`
  ${(props) => {
    function cssToComponent(dict: React.CSSProperties) {
      let str = '';
      for (const [key, value] of Object.entries(dict)) {
        let clo = '';
        key.split('').forEach((lt) => {
          if (lt.toUpperCase() === lt) {
            clo += '-' + lt.toLowerCase();
          } else {
            clo += lt;
          }
        });
        str += clo + ':' + value + ';';
      }
      return str;
    }
    return cssToComponent(props.propsStyle);
  }}
`;

const Font = {
  vi: "'Roboto', sans-serif",
  jp: "'Montserrat', sans-serif",
  en: "'Roboto', sans-serif",
};

export interface BaseTextProps {
  id?: string;
  default?: string;
  width?: string;
  height?: string;
  lineHeight?: string;
  color?: string;
  size?: string;
  background?: string;
  padding?: string;
  margin?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  marginBottom?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  fontFamily?: 'jpn' | 'eng' | 'vie';
  textDecorationLine?: React.CSSProperties['textDecorationLine'];
  fontWeight?: React.CSSProperties['fontWeight'];
  textAlign?: React.CSSProperties['textAlign'];
  display?: React.CSSProperties['display'];
  whiteSpace?: React.CSSProperties['whiteSpace'];
  overflow?: React.CSSProperties['overflow'];
  textOverflow?: React.CSSProperties['textOverflow'];
  href: string;
}

function getStyle(props: BaseTextProps) {
  const baseStyle: React.CSSProperties = {};
  props.width && (baseStyle.width = props.width);
  props.height && (baseStyle.height = props.height);
  props.color && (baseStyle.color = props.color);
  props.size && (baseStyle.fontSize = props.size);
  props.textAlign && (baseStyle.textAlign = props.textAlign);
  props.fontWeight && (baseStyle.fontWeight = props.fontWeight);
  props.background && (baseStyle.backgroundColor = props.background);
  props.padding && (baseStyle.padding = props.padding);
  props.margin && (baseStyle.margin = props.margin);
  props.marginTop && (baseStyle.marginTop = props.marginTop);
  props.marginLeft && (baseStyle.marginLeft = props.marginLeft);
  props.marginRight && (baseStyle.marginRight = props.marginRight);
  props.marginBottom && (baseStyle.marginBottom = props.marginBottom);
  props.lineHeight && (baseStyle.lineHeight = props.lineHeight);
  props.display && (baseStyle.display = props.display);
  props.textOverflow && (baseStyle.textOverflow = props.textOverflow);
  props.overflow && (baseStyle.overflow = props.overflow);
  props.whiteSpace && (baseStyle.whiteSpace = props.whiteSpace);
  baseStyle.textDecorationLine = props.textDecorationLine;
  const style = { ...baseStyle, ...(props.style ? props.style : {}) };
  return style;
}

export const ALink = (props: BaseTextProps) => {
  const { translation } = useTranslationText();
  const style = getStyle(props);

  const fontCode = props.fontFamily ? props.fontFamily : franc(innerText(props.children));

  switch (fontCode) {
    case 'eng':
      style.fontFamily = Font.en;
      break;
    case 'vie':
      style.fontFamily = Font.vi;
      break;
    default:
      style.fontFamily = Font.jp;
      break;
  }

  style.fontFamily = Font.vi;

  if (props.id) {
    return (
      <Wrapper {...props} propsStyle={style}>
        {translation(props.id)}
      </Wrapper>
    );
  } else {
    return (
      <Wrapper {...props} propsStyle={style}>
        {props.children ? props.children : ''}
      </Wrapper>
    );
  }
};
